<app-dashboard-layout-draggable (sendDraggable)="receiveDraggable($event)"></app-dashboard-layout-draggable>
<hr>
<app-dashboard-layout-color [dashboardLayout]="dashboardLayout"></app-dashboard-layout-color>
<app-dashboard-layout-columns [dashboardLayout]="dashboardLayout"></app-dashboard-layout-columns>
<app-dashboard-layout-padding [dashboardLayout]="dashboardLayout"></app-dashboard-layout-padding>
<hr>
<app-dashboard-layout-depth [dashboardLayout]="dashboardLayout"></app-dashboard-layout-depth>
<app-dashboard-layout-gap [dashboardLayout]="dashboardLayout"></app-dashboard-layout-gap>
<app-dashboard-layout-size [dashboardLayout]="dashboardLayout"></app-dashboard-layout-size>